import { render, staticRenderFns } from "./FinishOnboarding.vue?vue&type=template&id=2d5af70e&"
import script from "./FinishOnboarding.vue?vue&type=script&lang=js&"
export * from "./FinishOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports